import {
  LayoutDashboard,
  Key,
  Receipt,
  FileText,
  Box as BoxIcon,
  Users,
  ShieldCheck,
  UserCog,
  Scale,
  FileMinus,
  Bell,
  Coins,
  Wallet,
  FileCode2,
  ListOrdered,
  Landmark,
  Barcode,
} from "lucide-react";

export const PERMISSIONS = {
  // Sales
  LICENSE_READ: "license:read_all",
  RECEIPT_READ: "receipt:read_all",
  INVOICE_READ: "invoice:read_all",
  CREDIT_NOTE_READ: "credit_note:read_all",

  // Inventory
  PRODUCT_READ: "product:read_all",

  // Procurement
  PO_READ: "purchase_order:read_all",
  SUPPLIER_READ: "supplier:read_all",

  // CRM
  CUSTOMER_READ: "customer:read_all",

  // Finance
  PAYMENT_READ: "payment:read_all",

  FISCAL_ITEM_READ: "product:read_all",
  FISCAL_INVOICE_READ: "invoice:read_all",

  // Admin & Setup
  USER_READ: "user:read_all",
  ROLE_READ: "role:read_all",
  COMPANY_READ: "company:read",
  TAX_CODE_READ: "tax_code:read_all",
  PAYMENT_METHOD_READ: "payment_method:read_all",
  DOCUMENT_HEADER_READ: "document_header:read_all",
  SEQUENCES_READ: "sequence:read_all",
  REMINDER_LOG_READ: "reminder_log:read_all",
};

const createItem = (title, path, icon, permission, componentKey) => ({
  title,
  path,
  icon,
  permission,
  componentKey, // Strict plural naming convention
});

const createHeader = (title) => ({ isHeader: true, title });

export const SIDEBAR_ITEMS = [
  createItem("Dashboard", "/dashboard", LayoutDashboard, null, "DASHBOARD"),

  // --- Operations ---
  createHeader("Operations"),
  createItem(
    "Licenses",
    "/licenses",
    Key,
    PERMISSIONS.LICENSE_READ,
    "LICENSES",
  ),
  createItem(
    "Receipts",
    "/receipts",
    Receipt,
    PERMISSIONS.RECEIPT_READ,
    "RECEIPTS",
  ),
  createItem(
    "Invoices",
    "/invoices",
    FileText,
    PERMISSIONS.INVOICE_READ,
    "INVOICES",
  ),
  createItem(
    "Credit Notes",
    "/credit-notes",
    FileMinus,
    PERMISSIONS.CREDIT_NOTE_READ,
    "CREDIT_NOTES",
  ),

  // --- INVENTORY ---
  createHeader("Catalog"),
  createItem(
    "Products",
    "/products",
    BoxIcon,
    PERMISSIONS.PRODUCT_READ,
    "PRODUCTS",
  ),

  // --- CRM ---
  createHeader("CRM"),
  createItem(
    "Customers",
    "/customers",
    Users,
    PERMISSIONS.CUSTOMER_READ,
    "CUSTOMERS",
  ),

  // --- FINANCE ---
  createHeader("Finance"),
  createItem(
    "Payments",
    "/payments",
    Coins,
    PERMISSIONS.PAYMENT_READ,
    "PAYMENTS",
  ),

  createHeader("eTIMS Compliance"),
  createItem(
    "eTIMS Items",
    "/fiscal/items",
    Barcode,
    PERMISSIONS.FISCAL_ITEM_READ,
    "FISCAL_ITEMS",
  ),
  createItem(
    "eTIMS Invoices",
    "/fiscal/invoices",
    Landmark,
    PERMISSIONS.FISCAL_INVOICE_READ,
    "FISCAL_INVOICES",
  ),

  // --- ADMINISTRATION & SETUP ---
  createHeader("Administration"),
  createItem("System Users", "/users", UserCog, PERMISSIONS.USER_READ, "USERS"),
  createItem(
    "Roles & Permissions",
    "/roles",
    ShieldCheck,
    PERMISSIONS.ROLE_READ,
    "ROLES",
  ),
  createItem(
    "Tax Codes",
    "/tax-codes",
    Scale,
    PERMISSIONS.TAX_CODE_READ,
    "TAX_CODES",
  ),
  createItem(
    "Payment Methods",
    "/payment-methods",
    Wallet,
    PERMISSIONS.PAYMENT_METHOD_READ,
    "PAYMENT_METHODS",
  ),
  createItem(
    "Doc Templates",
    "/document-headers",
    FileCode2,
    PERMISSIONS.DOCUMENT_HEADER_READ,
    "DOCUMENT_HEADERS",
  ),
  createItem(
    "Sequences",
    "/sequences",
    ListOrdered,
    PERMISSIONS.SEQUENCES_READ,
    "SEQUENCES",
  ),
  createItem(
    "Reminders",
    "/reminders",
    Bell,
    PERMISSIONS.REMINDER_LOG_READ,
    "REMINDERS",
  ),
];
